import type { ArtifactExpiredError } from "../api";

interface Props {
  error: ArtifactExpiredError;
}

/**
 * Rendered by every artifact tab when the api returns 410 Gone with
 * `code=artifact_expired` (lifecycle-deleted) or `code=artifact_unavailable`
 * (job failed before producing it). The two codes get distinct messages
 * because the user's recovery action differs.
 */
export function ExpiredPlaceholder({ error }: Props) {
  const expiredAt = error.expiredAt ? formatDate(error.expiredAt) : null;
  if (error.code === "artifact_expired") {
    return (
      <div className="expired-state">
        <p>
          Artifacts {expiredAt ? `were auto-deleted on ${expiredAt}` : "have been auto-deleted"}.
        </p>
        <p className="muted">
          Re-submit the source video to regenerate.
        </p>
      </div>
    );
  }
  return (
    <div className="expired-state">
      <p>This artifact wasn't produced.</p>
      <p className="muted">
        The job didn't complete the stage that writes it — submit a new run if
        you'd like to try again.
      </p>
    </div>
  );
}

function formatDate(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
